<template>
    <div class="mainTabs-wrapper">
        <div v-show="isStarmateBoxVisible">
            <div id="parentTabIn" class="parentTabIn">
                <span class="backArrowIcon" id="close" @click="viewClose('someStatus')">
                    <img :src='downArrow' alt="Back Arrow" />
                </span>
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <div class="nav-link" :class="{ 'active': activeTab === 'charmTab' }"
                            @click="activateTab('charmTab')" data-toggle="tab" href="#charmTab" role="tab">Charm
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link" :class="{ 'active': activeTab === 'richTab' }"
                            @click="activateTab('richTab')" data-toggle="tab" href="#richTab" role="tab">Rich</div>
                    </li>
                    <li class="nav-item" style="display: none;">
                        <div class="nav-link" :class="{ 'active': activeTab === 'roomTab' }"
                            @click="activateTab('roomTab')" data-toggle="tab" href="#roomTab" role="tab">Room</div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link" :class="{ 'active': activeTab === 'callTab' }"
                            @click="activateTab('callTab')" data-toggle="tab" href="#callTab" role="tab">Call</div>
                    </li>
                    <li class="nav-item" style="display: none">
                        <div class="nav-link" :class="{ 'active': activeTab === 'agencyTab' }"
                            @click="activateTab('agencyTab')" data-toggle="tab" href="#agencyTab" role="tab">Agency
                        </div>
                    </li>

                    <li class="nav-item">
                        <div class="nav-link" :class="{ 'active': activeTab === 'topGameTab' }"
                            @click="activateTab('topGameTab')" data-toggle="tab" href="#topGameTab" role="tab">Game
                        </div>
                    </li>

                </ul>
                <div id="rankRewardInfoTab__"
                v-if="activeTab !== 'topGameTab'"
                @click="showRankRewardInfoTab"
                >
                    <div class="header-infoIcon"><img :src='infoIcon' alt="Info Icon" /></div>
                </div>
            </div>
            <div class="tab-content">
                <div class="tab-pane" :class="{ 'active active': activeTab === 'charmTab' }" id="charmTab"
                    role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedCharmTab">
                        <Charm />
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active active': activeTab === 'richTab' }" id="richTab"
                    role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedRichTab">
                        <Rich />
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active active': activeTab === 'roomTab' }" id="roomTab"
                    role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedRoomTab">
                        <Room />
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active active': activeTab === 'callTab' }" id="callTab"
                    role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedCallTab">
                        <Call />
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active active': activeTab === 'agencyTab' }" id="agencyTab"
                    role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedAgencyTab">
                        <Agency />
                    </div>
                </div>

                <div class="tab-pane" :class="{ 'active active': activeTab === 'topGameTab' }" id="topGameTab"
                    role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedTopGameTab">
                        <TopGames_2 />
                    </div>
                </div>

            </div>
        </div>
        <div id="rankRewardInfoTab" v-show="isRankRewardInfoTabVisible">
            <div class="tab-contentIn">
                <div class="">
                    <div class="headerWrapper rankRewardTopSec">
                        <div id="goParentTab" @click="activateTab('charmTab')" class="backArrowIcon">
                            <img :src='downArrow' alt="Back Arrow" />
                        </div>
                        <div class="rankingReward-HD">Ranking Rewards</div>
                    </div>
                    <div class="rankRewardContSec" v-if="isLoadedRankRewardInfoTab">
                        <RankRewardInfoComponent :currentTab="activeTab" @tab-changed="handleTabChange" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import downArrow from "../../assets/images/back-blackArrow.svg";
import infoIcon from "../../assets/images/infoIcon.png";
import { defineAsyncComponent } from "vue";

export default {
    name: "ParentTabComponent",
    components: {
        Charm: defineAsyncComponent(() => import("../Charm/CharmCompTab.vue")),
        Rich: defineAsyncComponent(() => import("../Rich/RichCompTab.vue")),
        Room: defineAsyncComponent(() => import("../Room/RoomCompTab.vue")),
        Call: defineAsyncComponent(() => import("../Call/CallCompTab.vue")),
        Agency: defineAsyncComponent(() => import("../Agency/AgencyCompTab.vue")),

        TopGames_2: defineAsyncComponent(() => import("../TopGames_2/TopGames_2.vue")),

        RankRewardInfoComponent: defineAsyncComponent(() =>
            import("../RankRewardInfoComponent/RankRewardInfoComponent.vue")
        ),
    },
    data() {
        return {
            activeTab: "charmTab",
            isStarmateBoxVisible: true,
            isRankRewardInfoTabVisible: false,
            downArrow,
            infoIcon,
            isLoadedCharmTab: false,
            isLoadedRichTab: false,
            isLoadedRoomTab: false,
            isLoadedCallTab: false,
            isLoadedAgencyTab: false,
            isLoadedRankRewardInfoTab: false,

            isLoadedTopGameTab: false
        };
    },
    mounted() {
        const navLinks = this.$el.querySelectorAll(".nav-link");
        navLinks.forEach((tab) => {
            tab.addEventListener("click", () => {
                tab.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center",
                });
            });
        });
        
        this.isLoadedCharmTab = true;
    },
    beforeUnmount() {
        document.body.classList.remove("topGameActive");
    },
    methods: {
        showRankRewardInfoTab() {
            this.isRankRewardInfoTabVisible = true;
            this.isStarmateBoxVisible = false;
            this.isLoadedRankRewardInfoTab = true;
        },
        activateTab(tabId) {
            this.isRankRewardInfoTabVisible = false;
            this.isStarmateBoxVisible = true;

            this.activeTab = tabId;

            if (tabId === "charmTab") this.isLoadedCharmTab = true;
            if (tabId === "richTab") this.isLoadedRichTab = true;
            if (tabId === "roomTab") this.isLoadedRoomTab = true;
            if (tabId === "callTab") this.isLoadedCallTab = true;
            if (tabId === "agencyTab") this.isLoadedAgencyTab = true;

            if (tabId === "topGameTab") this.isLoadedTopGameTab = true;

            // ✅ Body class add/remove logic
            if (tabId === "topGameTab") {
                document.body.classList.add("topGameActive");
            } else {
                document.body.classList.remove("topGameActive");
            }            
        },
        handleTabChange(tabId) {
            this.activateTab(tabId);
        },
        viewClose(status) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                Android.viewClose(status);
            }
        },
    },
};
</script>
